import { render, staticRenderFns } from "./DictionarySelect.vue?vue&type=template&id=b0418da6&scoped=true&"
import script from "./DictionarySelect.vue?vue&type=script&lang=js&"
export * from "./DictionarySelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0418da6",
  null
  
)

export default component.exports